import dayjs from 'dayjs';
import 'dayjs/locale/fr'; // Chargez la locale française comme base

// Extension de la locale française avec des personnalisations
const customFrenchLocale = {
  name: 'fr-custom',
  weekdays: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
  months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
  // Incluez d'autres personnalisations ici
};

// Appliquez la locale personnalisée en étendant 'fr'
dayjs.locale({...dayjs.Ls.fr, ...customFrenchLocale}, null, true);

export default dayjs;
